import { Button, Modal } from 'antd';
import React from 'react';
import { Link, useMatch } from 'react-router-dom';
import useAuthStore from '../../../../../store/authStore';
import useHomeStore from '../../../../../store/homeStore';
import useSearchStore from '../../../../../store/searchStore';
import AssociateWithCompanyModal from '../../../../features/Login/AssociateWithCompanyModal';
import AuthenticateModal from '../../../../features/Login/AuthenticateModal';
import SearchPop from '../../../../features/Search/SearchPop';
import ShoppingCart from '../../../../features/ShoppingCart/ShoppingCart';
import UserProfile from '../../../../features/UserProfile/UserProfile';
import SubscriptionExpiredModal from '../../Subscription/SubscriptionExpiredModal';
import ContactModal from '../ContactModal/ContactModal';
import DownloadApiModal from '../DownloadApiModal/DownloadApiModal';
import FeaturesModal from '../FeaturesModal/FeaturesModal';
import NotificationModal from '../NotificationModal/NotificationModal';
import PricingModal from '../PricingModal/PricingModal';

interface HeaderContainerProps {
  onNavigateHome: () => void;
  onCloseCart: () => void;
  onCloseUserProfile: () => void;
  onCloseAllModals: () => void;
  onCheckout: () => void;
}

export const HeaderContainer: React.FC<HeaderContainerProps> = ({
  onNavigateHome,
  onCloseCart,
  onCloseUserProfile,
  onCloseAllModals,
  onCheckout,
}) => {
  const showPricingModal = useHomeStore((state) => state.showPricingModal);
  const showDownloadApiModal = useHomeStore(
    (state) => state.showDownloadApiModal
  );

  const showContactModal = useHomeStore((state) => state.showContactModal);
  const showFeaturesModal = useHomeStore((state) => state.showFeaturesModal);
  const showNotifications = useHomeStore((state) => state.showNotifications);
  const showAssociateToCompany = useHomeStore(
    (state) => state.showAssociateToCompany
  );
  const showSubscriptionExpiredModal = useHomeStore(
    (state) => state.showSubscriptionExpiredModal
  );
  const showLogin = useHomeStore((state) => state.showLogin);
  const showSpectraModal = useHomeStore((state) => state.showSpectraModal);
  const showSearch = useHomeStore((state) => state.showSearch);
  const showCart = useHomeStore((state) => state.showCart);
  const showUserProfile = useHomeStore((state) => state.showUserProfile);

  const user = useAuthStore((state) => state.user);

  const isPaymentSuccessRoute = useMatch({
    path: '/paymentsuccess',
    end: true,
  });

  return (
    <>
      <PricingModal
        visible={showPricingModal}
        onHandlePricingModalCancel={onNavigateHome}
        handleCloseAllModals={onCloseAllModals}
      />

      <DownloadApiModal
        visible={showDownloadApiModal}
        onHandleDownloadApiModalCancel={onNavigateHome}
      />

      <ContactModal
        visible={showContactModal}
        onHandleContactModalCancel={onNavigateHome}
      />

      <FeaturesModal
        visible={showFeaturesModal}
        onHandleFeaturesModalCancel={onNavigateHome}
        handleCloseAllModals={onCloseAllModals}
      />

      <NotificationModal
        visible={showNotifications}
        onHandleNotificationModalCancel={onNavigateHome}
      />

      <SearchPop
        visible={showSearch}
        searchID={(id) => useSearchStore.getState().setSearchId(id)}
        onHandleDatasetsModalCancel={onNavigateHome}
      />

      <Modal
        closable={false}
        keyboard={false}
        open={isPaymentSuccessRoute !== null}
        zIndex={10001}
        title='Your data order is being processed'
        footer={
          <Link to='/'>
            <Button>OK</Button>
          </Link>
        }
      >
        An email with a link to download the data will be sent to you within a
        few minutes. You will be redirected to the main page.
      </Modal>

      {showCart && <ShoppingCart close={onCloseCart} checkout={onCheckout} />}
      {showUserProfile && (
        <UserProfile close={onCloseUserProfile} user={user} />
      )}
      {showAssociateToCompany.status && <AssociateWithCompanyModal />}
      {showSubscriptionExpiredModal.status && <SubscriptionExpiredModal />}
      {(showLogin || showSpectraModal) && <AuthenticateModal />}
    </>
  );
};
